export const SET_STEPPER = 'STEPPER';
export const NEXT_STEP = 'ACTIVE_STEP';
export const SET_STEPPER_LOADING = 'SET_STEPPER_LOADING';
export const GO_TO_STEP = 'GO_TO_STEP';
export const SET_URL = 'SET_URL';
export const RESET_STEPPER = 'RESET_STEPPER';
